module.exports = __webpack_public_path__ + "media/newstyle/images/record_voice_over-e8c81df611b15b689144981931941eda.svg";